import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/nurseries")({
  component: NurseriesPage,
});

function NurseriesPage() {
  return (
    <div className="container mx-auto py-6">
      <h1 className="text-2xl font-bold">Nurseries</h1>
      <p className="text-muted-foreground">Manage nurseries</p>
      {/* TODO: Implement nurseries view */}
    </div>
  );
}
